// Fleet Reports page state (2026-07-14). Client-only, lost on refresh — same
// acceptance as the ROI calculator. fuelPrices/actualSpend hold the Fuel-Cost
// calculator inputs (P3). NO serviceId here: it never crosses the wire — the
// backend derives it from the license.
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  startDate: null, // inclusive YYYY-MM-DD (tenant timezone)
  endDate: null,
  loaded: false, // true after the first Load click; gates the report query
  fuelPrices: {}, // { 'yyyy-mm-dd': number } — Fuel-Cost daily price inputs
  actualSpend: {}, // { sensorId: number } — Fuel-Cost weekly actual-spend inputs
};

export const reportingSlice = createSlice({
  name: "fleetReport",
  initialState,
  reducers: {
    // Shallow-merge, mirroring the GroupAnalyticsSlice/roiForm idiom.
    setFleetReport: (state, action) => {
      state = { ...state, ...action.payload };
      return state;
    },
    resetFleetReport: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const { setFleetReport, resetFleetReport } = reportingSlice.actions;

export default reportingSlice.reducer;
